// Fuente unica de las sedes para el front: la usan el JSON-LD, la cuenta
// regresiva, el archivo de calendario de /gracias y /calendario/<sede>.
// start/end tienen que coincidir con los de public/api/sedes.php (ics.php).
//
// El `slug` debe coincidir con los <option> del formulario y con las claves
// de $cities en public/api/register.php, que es lo que arma el correo.
//
// Las horas van en hora local de México (UTC-6).

const events = [
    {
        slug: 'cdmx',
        city: 'Ciudad de México',
        region: 'Ciudad de México',
        venue: 'Hotel Le Méridien',
        street: 'Av. Paseo de la Reforma 69, Tabacalera, Cuauhtémoc',
        start: '2026-10-06T16:00:00-06:00',
        end: '2026-10-06T21:00:00-06:00'
    },
    {
        slug: 'guadalajara',
        city: 'Guadalajara',
        region: 'Jalisco',
        venue: 'Hotel Guadalajara Plaza Expo',
        street: 'Av. Mariano Otero 3261, Verde Valle',
        start: '2026-10-08T16:00:00-06:00',
        end: '2026-10-08T21:00:00-06:00'
    },
    {
        slug: 'monterrey',
        city: 'Monterrey',
        region: 'Nuevo León',
        // Direccion oficial del hotel, confirmada por el cliente el 14/08/2026.
        // Tiene que quedar igual que en api/sedes.php para que el correo, el
        // calendario y el JSON-LD no se contradigan.
        venue: 'Hotel Antaris Cintermex',
        street: 'Av. Fundidora 500, Col. Obrera, C.P. 64010',
        start: '2026-10-10T09:00:00-06:00',
        end: '2026-10-10T14:00:00-06:00'
    }
];

export const findEventBySlug = (slug) =>
    events.find((event) => event.slug === slug) || null;

export default events;
